import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Container, Image } from 'react-bootstrap';
import Header from '../Header/Header';
import { BsFillShareFill } from 'react-icons/bs';

import Footer from '../Footer/Footer';
import { Link, withRouter } from 'react-router-dom';
import PopularBox from './PopularBox';
import Clients from './Clients';
import { get, getList, post } from '../helpers/api_helper';
import { connect } from 'react-redux';
import OpportunitieList from './OpportunitieList';
import Marquee from "react-fast-marquee";
import Loader from '../components/Loader/Loader';
function Home(props) {
  const [joblist, setJoblist] = useState([]);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    getListingjob();

  }, []);


  //  const user = props;

  //  console.log('home data',props);


  const getListingjob = () => {
    setLoader(true);
    getList('/oppor/list?limit=10').then((json) => {
      if (json.statusCode == 200) {
        setLoader(false);
        setJoblist(json);
        console.log('oppolist', json)

      }else{
        setLoader(false);
      }

    })

  }



  const routerFunction = (item) => {
    let title = item?.title.toLowerCase();
    let path = title.split(" ").join("_") + "_" + item?._id;
    //    console.log('path generated', path);
    props.history.push("/opportunity/" + path);
    localStorage.setItem('opprtunity', path);
    // console.log('item ', item)
  }

  console.log('joblist'.joblist)
  return (
    <>
     {loader && <Loader />}
     <div>

      <div className='banner-section'>
        <section className='latest-job'>
          <Marquee pauseOnHover={true} speed={2}>
            <ul className='latest_job'>
              {
                joblist.data?.map((item, i) => {
                  return (
                    <li><a href="javascript:void(0);" onClick={() => routerFunction(item)}>{item?.title},  {item?.company[0]?.title}</a></li>
                  )
                })
              }
            </ul>
          </Marquee>
        </section>
        <img src={require('../assets/images/bg.jpg')} alt="banner" className='banner_i' />
        <div className='banner-content'>
          <div className='b-content'>
            <h1>Find an Apprenticeship</h1>
            <h2>Opportunity with</h2>
            <h3>Apprenticeshipwale.com</h3>
          </div>
        </div>

      </div>
      <section className='section-0'>
        <Container className='card-box'>
          <Row>
            <Col md={3} sm={6}>
              <div className='banner-box'>
                <Card>
                  <div className='left-content'>
                    <h5>Permanent / Temporary Staffing</h5>

                  </div>
                  <div className='icon-box'>
                    <img src={require('../assets/images/icon.png')} alt="icon" />
                  </div>
                </Card>
              </div>
            </Col>
            <Col md={3} sm={6}>
              <div className='banner-box'>
                <Card>
                  <div className='left-content'>
                    <h5>Payroll & Complances</h5>

                  </div>
                  <div className='icon-box'>
                    <img src={require('../assets/images/icon1.png')} alt="icon" />
                  </div>
                </Card>
              </div>
            </Col>
            <Col md={3} sm={6}>
              <div className='banner-box'>
                <Card>
                  <div className='left-content'>
                    <h5>Campus Requirement</h5>

                  </div>
                  <div className='icon-box'>
                    <img src={require('../assets/images/icon2.png')} alt="icon" />
                  </div>
                </Card>
              </div>
            </Col>
            <Col md={3} sm={6}>
              <div className='banner-box'>
                <Card>
                  <div className='left-content'>
                    <h5>Work integrated Education Course</h5>

                  </div>
                  <div className='icon-box'>
                    <img src={require('../assets/images/icon2.png')} alt="icon" />
                  </div>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='section-1 section'>
        <h1 className='title-heading op_heading'>Top Opportunities</h1>
        <OpportunitieList for={false} history={props.history} />
      </section>
      <div className='section-10'>
        <Row>
          <Col lg={12}>
            <PopularBox />
          </Col>
        </Row>
      </div>
      <section className='section-2 section'>
        <Container fluid>
          <Row>
            <Col lg={6}>
              <div className='solution-box'>
                <h5 className='sub-heading'>About apprenticeshipwale </h5>
                <h1 className='title-heading'>
                  Dedicated Solutions with
                  30 Years Experience
                </h1>
                <p>Our team of experts is dedicated to providing customized staffing solutions that meet the unique requirements of your organization. With our comprehensive range of services, we ensure that your business is always equipped with the right talent to drive success.</p>
                <ul>

                  <li>
                    <img src={require('../assets/images/icon3.png')} alt="icon3" />
                  </li>
                  <li>
                    <img src={require('../assets/images/icon4.png')} alt="icon4" />
                  </li>
                  <li>
                    <img src={require('../assets/images/icon5.png')} alt="icon5" />
                  </li>
                </ul>
                <Link to="/about" className='kn_btn'>Know More</Link>
              </div>
            </Col>
            <Col lg={6}>
              <div className='right-img-box'>
                <div className='img-b'>
                  <img src={require('../assets/images/img1.jpg')} alt="img1" />
                </div>
                <div className='img-b'>
                  <img src={require('../assets/images/img.jpg')} alt="img" />
                </div>

              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className='section-3'>
        <img src={require('../assets/images/bg-1.jpg')} className="section3-img" alt="bg-1" />
        <div className='section_3_box'>
          <div className='heading-section'>
            <div className='left-content-box'>
              <h5 className='sub-heading'>AUTHORS ARTICLES</h5>
              <h1 className='title-heading'>
                Amazing Articles <br />About apprenticeship
              </h1>
            </div>
            {/* <div className='right-box-btn'>
              <a href="#" className='kn_btn'>Know More</a>
            </div> */}
          </div>
          <Row className='amazing-section'>
            <Col lg={6}>
              <Card className='card-box-3 card-1'>
                <Link to="/the-future-of-Work-why-apprenticeships-will-be-key-to-bridging-the-skills-gap">
                  <div className='img-box-3'>
                    <img src={require('../assets/images/blog/thumb1.jpg')} alt="bg-1" />
                  </div>
                  <div className='card-content-box'>
                    <p>20, March 2023</p>
                    <h2>The Future of Work: Why Apprenticeships Will Be Key to Bridging the Skills Gap</h2>
                  </div>
                </Link>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className='card-box-3 card-2'>

                <Link to="/from-learning-to-earning-the-benefits-of-apprenticeships-for-young-professional">
                  <div className='img-box-3'>
                  <img src={require('../assets/images/blog/thumb2.jpg')} alt="bg-2" />
                  </div>
                  <div className='card-content-box'>
                    <p>30, March 2023</p>
                    <h2>From Learning to Earning: The Benefits of Apprenticeships for Young Professional</h2>
                  </div>
                </Link>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className='card-box-3 card-2'>
                <Link to="/how-apprenticeship-training-is-revolutionizing-the-tech-industry">
                  <div className='img-box-3'>
                  <img src={require('../assets/images/blog/thumb3.jpg')} alt="bg-3" />
                  </div>
                  <div className='card-content-box'>
                    <p>05, April 2023</p>
                    <h2>How Apprenticeship Training is Revolutionizing the Tech Industry.</h2>
                  </div>
                </Link>
              </Card>
            </Col>
          </Row>
        </div>
      </section>

      <Clients />

    </div>
    </>
  )
}


const mapStateToProps = state => {
  // console.log('state at home', state);
  const { user } = state;
  return { user }
}

export default withRouter(
  connect(mapStateToProps)(Home)
)